import React from 'react'
import icon from './svgs/verifyGray.svg'
import { BaseIcon } from './_base'

export const VerifyGrayIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
